import React, { useMemo } from "react";
import { styled } from "styled-components";
import defaultSocialLinks from "../FooterSocialLinks/defaultSocialLinks";
import { Twitter, Instagram, Facebook, YouTube } from "../../../icons";
const Socials = styled.div `
  display: flex;
  flex-direction: row;
`;
const SocialAnchor = styled.a `
  display: block;
  margin-right: 10px;
  cursor: pointer;
  svg {
    width: 25px;
    height: 25px;
  }
`;
const getSocialIcon = (provider) => {
    switch (provider) {
        case "facebook":
            return React.createElement(Facebook, null);
        case "instagram":
            return React.createElement(Instagram, null);
        case "twitter":
            return React.createElement(Twitter, null);
        case "youtube":
            return React.createElement(YouTube, null);
        default:
            return null;
    }
};
export const FooterSocialLinks = ({ locale, socialLinks = defaultSocialLinks, }) => {
    const socials = useMemo(() => socialLinks.filter((social) => social.supportedLanguages.includes(locale)), [locale, socialLinks]);
    return (React.createElement(React.Fragment, null, socialLinks.length > 0 && (React.createElement(React.Fragment, null,
        React.createElement(Socials, null, socials.map((social) => {
            const icon = social.type;
            const socialUrl = social.url[locale];
            return (React.createElement(SocialAnchor, { target: "_blank", rel: "noopener", title: social.title, key: social.type, href: socialUrl }, getSocialIcon(icon)));
        }))))));
};
export default FooterSocialLinks;
//# sourceMappingURL=index.js.map